import React from 'react'
import tankImage from "../../../images/products/F.png"
import HeaderTopS3 from '../../../components/HeaderTopS3/HeaderTopS3'
import NavbarS3 from '../../../components/NavbarS3/NavbarS3'
import Logo from '../../../images/snbs_logo1.png'
import PageTitle from '../../../components/pagetitle/PageTitle'
import Footer from '../../../components/footer/Footer'
import Img from '../../../images/home/p-2.jpg'

function CorrugatedBox() {

  const values = [
  {
    number: 1,
    text: "Strong and durable – Built with multi-layer kraft paper for superior strength and protection.",
  },
  {
    number: 2,
    text: "Lightweight – Easy to handle and reduces shipping costs without compromising safety.",
  },
  {
    number: 3,
    text: "Shock absorbent – Provides cushioning to protect items from impact during transit.",
  },
  {
    number: 4,
    text: "Customizable – Available in different sizes, shapes, ply options, and branding prints.",
  },
  {
    number: 5,
    text: "Eco-friendly – Made from recyclable and biodegradable materials for sustainable packaging.",
  },
  {
    number: 6,
    text: "Cost-effective – Offers reliable packaging at an affordable price for bulk shipments.",
  },
  {
    number: 7,
    text: "Stackable – Designed for easy stacking and efficient space usage during storage or transport.",
  },
  {
    number: 8,
    text: "Versatile use – Ideal for e-commerce, electronics, retail goods, food, and industrial items.",
  },
];


  return (
    <>
     <HeaderTopS3 />
     <NavbarS3 hclass={'wpo-site-header wpo-header-style-3'} Logo={Logo} />
      <PageTitle pageTitle={'Corrugated Box'} pagesub={'Products'} Img={Img} />
      <section className="container pt-100">
      <div className="row align-items-center">
        {/* Left Column - Text */}
        <div className="col-lg-6 col-md-12 col-sm-12 text-center">
          <img
            src={tankImage}
            alt="Water Tank" />
        </div>

        {/* Right Column - Image */}
        <div className="col-lg-6 col-md-12 col-sm-12 mb-4">
  <h2 className="fw-bold mb-3">Smart Packaging. Safe Delivery.</h2>
  <p style={{ textAlign: "justify" }}>
    Corrugated boxes are the most trusted solution for packaging, storing, and shipping a wide range of products. Known for their strength, lightweight structure, and eco-friendly nature, they are widely used across industries—from e-commerce to agriculture.
  </p>
  <p style={{ textAlign: "justify" }}>
    At SNBS, we manufacture high-quality corrugated boxes using durable kraft paper and multi-layer board structures. These boxes provide excellent protection against impact, compression, and stacking pressure, ensuring your products stay safe during transport and storage.
  </p>
  <p style={{ textAlign: "justify" }}>
    Available in 3-ply, 5-ply, and 7-ply options, our boxes come in various sizes and styles, including printed and plain versions. They’re ideal for packaging electronics, consumer goods, machinery parts, and more—offering a cost-effective and customizable packaging solution.
  </p>
</div>

      </div>
    </section>
 {/* <div className="container pt-100 pb-100">
      <h2 className="text-center fw-bold mb-4">Corrugated Box</h2>
      <div className="table-responsive">
        <table className="table table-bordered text-center mb-4">
          <thead className="table-primary">
            <tr>
              <th colSpan="5" className="bg-primary text-white">
             Corrugated Box available in various liters
              </th>
            </tr>
            <tr>
              <th>Liter</th>
              <th>3000</th>
              <th>5000</th>
              <th>7500</th>
              <th>10000</th>
            </tr>
          </thead>
        </table>

        <table className="table table-bordered text-center">
          <thead className="table-primary">
            <tr>
              <th colSpan="5" className="bg-primary text-white">
               Leno Bag Size Chart
              </th>
            </tr>
          </thead>
          <tbody>
            <tr className="table-light">
              <th>Size</th>
              <th>3000</th>
              <th>5000</th>
              <th>7500</th>
              <th>10000</th>
            </tr>
            <tr className="table-light">
              <th>Height (mm)</th>
              <td>1850</td>
              <td>2070</td>
              <td>2650</td>
              <td>3050</td>
            </tr>
            <tr className="table-light">
              <th>Diameter (mm)</th>
              <td>1550</td>
              <td>1870</td>
              <td>1940</td>
              <td>2120</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div> */}
<section style={{backgroundColor:"#f3f3f6"}}>
   <div className="container pt-100 pb-100" >
      <h2 className="text-center fw-bold mb-4">Product Features</h2>
      <div className="row">
        {values.map((item, index) => (
          <div key={index} className="col-md-6 mb-4 d-flex">
            <div
              className="rounded-circle bg-dark text-white d-flex align-items-center justify-content-center me-3"
              style={{ width: "40px", height: "40px", flexShrink: 0 }}>
              {item.number}
            </div>
            <p className="mb-2">{item.text}</p>
          </div>
        ))}
      </div>
    </div>
 </section>
    <Footer hclass={'wpo-site-footer mt-0'} upperContactArea={true} />
    </>
  )
}

export default CorrugatedBox